import { ActionTypes } from '../../constants/ActionTypes';
import { INewLetterReducer } from '../../interfaces/NewLetter';
const INIT_STATE: INewLetterReducer = {
  newLetter: {
    letterCode: '',
  },
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CREATE_LETTER: {
      return {
        ...state,
      };
    }

    case ActionTypes.CREATE_LETTER_SUCCESS: {
      return {
        ...state,
        letterCode: action.payload,
      };
    }

    default:
      return state;
  }
};
